import { render, staticRenderFns } from "./ProcesoCompraAmigoAbonadoSga.vue?vue&type=template&id=6bfb352c"
import script from "./ProcesoCompraAmigoAbonadoSga.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcesoCompraAmigoAbonadoSga.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports